import React from "react"

const SeoContext = React.createContext(null)

export default SeoContext
